import React, { useCallback } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SocketClientType } from '@/service/socketio';
import { MusicThemeText } from '../utils';

import cx from './index.module.scss';

interface Props {
  socketInstance: React.MutableRefObject<SocketClientType>;
  bgmInfo: GetMachineStateResponse['background_music'];
  currentThemeId: SetBackgroundMusicNameParams['name'];
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SwitchBgMusic: React.FC<Props> = ({ open, setOpen, currentThemeId, bgmInfo, socketInstance }) => {
  const handleSwitchMusic: (item: Props['currentThemeId']) => React.MouseEventHandler<HTMLDivElement> = useCallback(
    item => async e => {
      e?.stopPropagation();
      await socketInstance.current?.setBackgroundMusic({ enable: true });
      await socketInstance.current?.setBackgroundMusicName({ name: item });
      setTimeout(() => setOpen(false), 400);
    },
    [setOpen, socketInstance]
  );

  const handleDisableMusic = useCallback(
    async e => {
      e?.stopPropagation();
      await socketInstance.current?.setBackgroundMusic({ enable: false });
      setTimeout(() => setOpen(false), 400);
    },
    [setOpen, socketInstance]
  );

  return (
    <AnimatePresence>
      {open && (
        <div className={cx('SwitchBgMusic')} onClick={() => setOpen(false)}>
          <motion.div
            key="switcher"
            transition={{ duration: 0.2 }}
            initial={{ transform: 'translateY(30px)', opacity: 0 }}
            animate={{ transform: 'none', opacity: 1 }}
            exit={{ transform: 'translateY(30px)', opacity: 0 }}
            className={cx('theme-box')}
          >
            <div className={cx('theme-item', { current: !bgmInfo?.enable })} onClick={handleDisableMusic}>
              {!bgmInfo?.enable && <div className={cx('line')} />}
              <span>关闭</span>
            </div>
            {Object.keys(MusicThemeText).map(item => (
              <div
                className={cx('theme-item', { current: bgmInfo?.enable && currentThemeId === item })}
                key={item}
                onClick={handleSwitchMusic(item as Props['currentThemeId'])}
              >
                {currentThemeId === item && bgmInfo?.enable && <div className={cx('line')} />}
                <span>{MusicThemeText[item]}</span>
              </div>
            ))}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default SwitchBgMusic;
